import React from 'react'
import styled from 'styled-components'
import { ButtonFooter } from 'app/ecommerce/common/components/button-footer/ButtonFooter'
import { formatPrice } from 'shared/utils'
import { Link } from 'app/common/link'
import { CartToast } from 'app/ecommerce/common/components/cart-toast'
import { useIntl } from 'react-intl'

type Props = {
    price?: number
}

export const CartFooter = ({ price = 0 }: Props) => {
    const intl = useIntl()
    return (
        <Container>
            <CartToast />
            <Background>
                <Row
                    url={intl.formatMessage({
                        id: 'routes.clickandcollect.cart.summary'
                    })}>
                    <ButtonFooter
                        labelKey={
                            price && price >= 0
                                ? 'clickandcollect.cart.footer'
                                : 'clickandcollect.cart.footer.no.price'
                        }
                        labelParams={{ price: formatPrice(price) }}
                    />
                </Row>
            </Background>
        </Container>
    )
}

const Container = styled.div`
    background-color: none;
`

const Background = styled.div`
    position: relative;
    z-index: 100;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: white;
    border-top: solid 1px #d8d8d8;
`

const Row = styled(Link)`
    display: flex;
    width: 100%;
`
